import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, HostBinding, OnInit } from '@angular/core';
import { Register } from '@app/utils/type-registry';
import {
  InsertRemoveTriggerInput,
  InsertRemoveTriggerOutput,
} from '@trackback/widgets';
import { ParsePipe } from '@app/pipes/parse.pipe';
import { DynamicWidgetDirective } from '@app/directives/dynamic-widget.directive';
import { BaseWidgetComponent } from '@app/widgets/base-widget.component';

@Register(['InsertRemoveTrigger', 'AnimateInsertRemove'])
@Component({
  selector: 'tb-insert-remove-animate',
  animations: [
    trigger('myInsertRemoveTrigger', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('1s', style({ opacity: 1 })),
      ]),
      transition(':leave', [animate('1s', style({ opacity: 0 }))]),
    ]),
  ],
  template: `
    @if (input.isShown | parse: context | async) {
      <div @myInsertRemoveTrigger>
        @for (widget of input.widgets; track widget) {
          <ng-container
            [dynamicWidget]="widget"
            [context]="context"
          ></ng-container>
        }
      </div>
    }
  `,
  imports: [CommonModule, ParsePipe, DynamicWidgetDirective],
})
export class InsertRemoveTriggerComponent
  extends BaseWidgetComponent<
    InsertRemoveTriggerInput,
    InsertRemoveTriggerOutput
  >
  implements OnInit
{
  @HostBinding('style.paddingTop')
  paddingTop?: string;
  @HostBinding('style.paddingRight')
  paddingRight?: string;
  @HostBinding('style.paddingBottom')
  paddingBottom?: string;
  @HostBinding('style.paddingLeft')
  paddingLeft?: string;
}
